import React, { useState, useEffect } from "react";
import styles from "./authHomepage.module.css";
import AddPost from "../../../components/addPost/AddPost";
import LearningZonesComp from "../../../components/learningZonesComp/LearningZonesComp";
import SearchComp from "../../../components/search/SearchComp";
import LanguagePalsComp from "../../../components/languagePals/LanguagePalsComp";
import axios from "axios";
import OtherPeoplePosts from "../../../components/personalPosts/OtherPeoplePosts";

const apiUrl = process.env.REACT_APP_URL;

function AuthHomepage() {
  /*
  Authenticated Homepage - the home page of a logged in user. This page contains the user's feed - posts and comments he / she can view. The page also has quick access side components: Search, Pals, and Learning Zones.
  */
  const [profileData, setProfileData] = useState({
    img_link: "",
    username: "",
    role: "",
  });

  // Fetch profile data
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        // First, get the username from the session
        const sessionRes = await axios.get(`${apiUrl}/auth/user`, {
          withCredentials: true,
        });

        if (sessionRes.status === 200 && sessionRes.data.success) {
          const username = sessionRes.data.username;

          // Use the username to get user info
          const userRes = await axios.get(`${apiUrl}/users/${username}`, {
            withCredentials: true,
          });

          if (userRes.status === 200) {
            setProfileData({
              img_link: userRes.data.img_link,
              username: userRes.data.username,
              role: userRes.data.role,
            });
          }
        }
      } catch (e) {
        console.error("Failed to fetch profile data", e);
      }
    };

    fetchProfileData();
  }, []);

  return (
    <div className={styles.main}>
      {/* main layout  */}
      <section className={styles.mainLayout}>
        {/* left section  */}
        <div className={styles.left}>
          <LearningZonesComp />
        </div>

        {/* middle section  */}
        <div className={styles.middle}>
          <AddPost
            userImage={profileData.img_link}
            username={profileData.username}
          />
          <OtherPeoplePosts
            role={profileData.role}
            username={profileData.username}
            userImage={profileData.img_link}
          />
        </div>

        {/* right section  */}
        <div className={styles.right}>
          <SearchComp />
          <LanguagePalsComp isOwn={true} />
        </div>
      </section>
    </div>
  );
}

export default AuthHomepage;
